import { useState } from "react";
import { db } from "../firebase";
import { addData } from "../Firebase/firestore";

function Register_form({notify}) {

    const [loading, setLoading] = useState(false);

    const [success, setSuccess] = useState(false);

    const onSubmit = async (event) => {
        try{
            setLoading(true)
            event.preventDefault();
            const formData = new FormData(event.target);
            const data = {
                name: formData.get("name"),
                email: formData.get("email"),
                phone: formData.get("phone"),
                college: formData.get("college"),
                requirement: formData.get("requirement")
            };
            const coll = db.collection("register")
            addData(coll, null,  data)
            setLoading(false) 
            notify()
            setSuccess(true);
            console.log("Form submitted:", data);
        } catch(e){
            setLoading(false);
            window.location.reload();
        }
    };

    return ( 
        <div className="register_form_container">

            {(loading) && 
                (<div className='f-loading'>
                            <img alt src={"https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif"} onerror="this.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'"/>
            </div>)}
                
            {!success && <h2>Register</h2>}
            {!success ? 
            <form className="register_form" onSubmit={async (e)=>{await onSubmit(e)}}>
                <div>
                    <label htmlFor="name">Name <span>*</span> </label>
                    <input type="text" id="name" name="name" required placeholder="eg: John Doe"/>
                </div>
                <div>
                    <label htmlFor="email">Email <span>*</span> </label>
                    <input type="email" id="email" name="email" required placeholder="eg: john@gmail.com"/>
                </div>
                <div>
                    <label htmlFor="phone">Phone <span>*</span> </label>
                    <input type="tel" id="phone" name="phone" required placeholder="eg: 9087766456"/>
                </div>
                <div>
                    <label htmlFor="college">College <span>*</span> </label>
                    <input type="text" id="college" name="college" required placeholder="eg: ABC College"/>
                </div>
                <div>
                    <label htmlFor="requirement">Requirement</label>
                    <textarea type="text" id="requirement" name="requirement" placeholder="what are you looking for ?"/>
                </div>
                <button type="submit" className="Butt2 hori_center">
                    <span>Submit</span></button>
            </form>
            : 
            <div className="FIT_W FIT_H hori_center">
                <div>   
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"> <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg>
                </div>
                <span className="txt-font1">Registration Success</span>
            </div>}
        </div>
     );
}

export default Register_form;